module.exports = __webpack_public_path__ + "static/media/grid.480d7a3c.md";